<!-- =========================================================================================
  File Name: MailSendResume.vue
  Description: MailSendResume page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

    <div id="page-user-list" class="vx-card p-6">

      <!-- Searchs-->
      <vx-card ref="filterCard" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
        <div class="vx-row">
          <div class="vx-col md:w-1/6 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">企業ID</label>
            <vs-input class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" placeholder="企業ID" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="searchCondition.companyId"/>
          </div>
          <div class="vx-col md:w-1/6 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">宛先</label>
            <vs-input class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" placeholder="宛先" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="searchCondition.address"/>
          </div>
          <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">機能</label>
            <v-select class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                      label="value" :searchable="false" :reduce="item => item.key" :options="templateList" v-model="searchCondition.template">
            </v-select>
          </div>
          <div class="vx-col md:w-1/6 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">送信状態</label>
            <v-select class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                      label="value" :searchable="false" :reduce="item => item.key" :options="stateList" v-model="searchCondition.state">
            </v-select>
          </div>
          <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          </div>
          <div class="vx-col md:w-1/6 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">送信日時/時刻</label>
            <flat-pickr
                class="w-full flatpickr-style"
                v-model="searchCondition.sendFrom"
                placeholder="..."
                :config="configDate"
            >
            </flat-pickr>
          </div>
          <div class="vx-col md:w-1/6 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">&nbsp;</label>
            <flat-pickr
                class="w-full flatpickr-style"
                v-model="searchCondition.sendTo"
                placeholder="..."
                :config="configDate"
            >
            </flat-pickr>
          </div>
          <div class="vx-col md:w-1/6 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">リクエスト日時/時刻</label>
            <flat-pickr
                class="w-full flatpickr-style"
                v-model="searchCondition.requestFrom"
                placeholder="..."
                :config="configDate"
            >
            </flat-pickr>
          </div>
          <div class="vx-col md:w-1/6 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">&nbsp;</label>
            <flat-pickr
                class="w-full flatpickr-style"
                v-model="searchCondition.requestTo"
                placeholder="..."
                :config="configDate"
            >
            </flat-pickr>
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full flex flex-wrap items-end justify-end div-search-bnt">
            <vs-button icon="search" @click="searchMailWithOrder()" class="search_icon mr-6 sm:mr-3">検索</vs-button>
          </div>
        </div>
      </vx-card>

      <!-- Title and Buttons Action -->
      <div class="text-title">
        <span>送信一覧</span>
      </div>
      <vs-row class="pl-2">
        <vs-col class="flex flex-wrap items-center justify-start pl-6" vs-w="6">
          <span class="pr-2">表示件数:</span>
          <div class="vx-col md:w-24 w-full">
            <v-select class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" :options="paginationOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="paginationPageSize">
              <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
            </v-select>
          </div>
        </vs-col>
        <vs-col class="flex flex-wrap items-center md:justify-end justify-evenly" vs-w="6">

        </vs-col>
      </vs-row>

      <!-- Show Dialog -->
      <vs-popup id="dialogUpdate" title="詳細" :active.sync="activePopup" button-close-hidden>
        <div>
          <div>
            <vx-card card-background ="rgb(240, 238, 241)"

            class="pb-2"
            style="font-size: 12px">
              <div>
                <vs-row class="mt-3">
                  <vs-col class="flex items-center" vs-w="2">
                    <span>宛先</span>
                  </vs-col>
                  <vs-col vs-w="10">
                    <span>{{ item.to_email }}</span>
                  </vs-col>
                </vs-row>
                <vs-row class="mt-3">
                  <vs-col class="flex items-center" vs-w="2">
                    <span>件名</span>
                  </vs-col>
                  <vs-col vs-w="10">
                    <span>{{ item.subject }}</span>
                  </vs-col>
                </vs-row>
                <vs-row class="mt-3">
                  <vs-col class="flex items-center" vs-w="2">
                    <span>本文</span>
                  </vs-col>
                  <vs-col vs-w="10">
                    <div  style="word-break: break-word">{{ item.body }}</div>
                  </vs-col>
                </vs-row>
              </div>
            </vx-card>
          </div>
          <div style="display: flex; justify-content: flex-end" class="pt-4">
            <vs-button @click="activePopup = false" icon="cancel" color="lightgrey" style="padding: 8px; margin-right: 5px;height: 37px">閉じる</vs-button>
          </div>
        </div>
      </vs-popup>

      <!-- AgGrid Table -->
      <ag-grid-vue
        id="myGrid"
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table database"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="items"
        rowSelection="single"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        :domLayout="domLayout"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        @selection-changed="onSelectionChanged"
        @sortChanged="onSortChangedEvent"
        :overlayNoRowsTemplate="noRowsTemplate"
        :detailRowAutoHeight="true"
      >
      </ag-grid-vue>

      <div style="position: relative">
      <!-- ITEMS PER PAGE -->
        <div>
            <div class="flex items-center justify-between">
              <span class="pl-2 mr-2" style="font: 400 13.3333px Arial">{{ totalRow }} 件中 {{ startRow }} 件から {{ endRow }} 件までを表示</span>
            </div>
        </div>
      <!-- pagination -->
        <vs-pagination
            :total="totalPages"
            v-model="currentPage"
            :max="0"
            class="pr-10 pt-10"
            />
    </div>
  </div>

</template>

<script>
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import { AgGridVue } from 'ag-grid-vue'
import vSelect       from 'vue-select'
import EventBus      from '../../../EventBus'
import {mapActions, mapGetters} from 'vuex'
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";

// Cell Renderer
import CellRendererActions from '@/components/cell-renderer/CellRendererActions.vue'

export default {
  components: {
    AgGridVue,
    vSelect,
    flatPickr,
    // Cell Renderer
    CellRendererActions
  },
  data () {
    return {
      configDate: {
        locale: Japanese,
        wrap: true,
        defaultHour: 0,
        maxDate: "",
        enableTime: true,
        time_24hr: false
      },
      searchCondition:{
        // Filter Options Search
        companyId: "",
        address: "",
        template: null,
        state: null,
        sendFrom: null,
        sendTo: null,
        requestFrom: null,
        requestTo: null,
      },
      activePopup:     false,
      item:           '',

      paginationOptions: [
        10, 20, 30, 50
      ],

      //SortServer
      orderBy: 'id',
      orderDir: 'desc',

      //Pagination
      paginationPageSize: 10,
      pageNumber: 1,
      startRow: 0,
      endRow: 0,

      // AgGrid
      noRowsTemplate: "<span>データがありません</span>",
      domLayout: 'autoHeight',
      gridApi: null,
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridApi.sizeColumnsToFit();
        }
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        sortingOrder: ['asc', 'desc'],
      },
      stateList: [
        { key: null, value: '...'},
        { key: 0, value: '送信待ち'},
        { key: 1, value: '送信中'},
        { key: 2, value: '送信成功'},
        { key: 3, value: '送信失敗'},
      ],
      templateList: [],
      columnDefs: [
        {
          headerName: '送信日時',
          field: 'update_at',
          filter: true,
          width: 35,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '企業',
          field: 'company_name',
          filter: true,
          width: 50,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '企業ID',
          field: 'mst_company_id',
          filter: true,
          width: 20,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '宛先',
          field: 'to_email',
          filter: true,
          width: 50,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '機能',
          field: 'template_name',
          filter: true,
          width: 40,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '発生日時',
          field: 'create_at',
          filter: true,
          width: 35,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '送信状態',
          field: 'state_name',
          filter: true,
          width: 25,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '送信回数',
          field: 'send_times',
          filter: true,
          width: 20,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '',
          field: 'transactions',
          width: 8,
          cellRendererFramework: 'CellRendererActions',
          cellRendererParams: {
            hideDelete: true,
            hideEdit: true,
            showDetail: true,
          },
          unSortIcon: false,
          suppressMovable: true,
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererActions
      }
    }
  },
  watch: {
    paginationPageSize(val){
      this.setPagination(val);
    }
  },
  computed: {
    ...mapGetters({
      getMailSendResume:  'mailSendResume/getMailSendResume'
    }),
    validateForm(){
      return !this.errors.any()
    },
    items () {
      let items = []
      this.$store.state.mailSendResume.mailSendResumes.forEach((element) => {
        if (!element.company_name) element.company_name = '社外'
        items.push(Object.assign(element));
      });
      return items
    },
    totalPages () {
      return parseInt(this.$store.state.mailSendResume.infoDB.totalPage)
    },
    totalRow(){
      return parseInt(this.$store.state.mailSendResume.infoDB.totalRow)
    },
    currentPage: {
      get () {
        return this.pageNumber
      },
      async set (val) {
        this.pageNumber = val
        await this.searchMailWithOrder();
        this.ids = []
        this.gridApi.paginationGoToPage(val-1)
      }
    }
  },
  methods: {
    ...mapActions({
      showMailSendResume:      'mailSendResume/showMailSendResume',
      fetchMailSendResume:     'mailSendResume/fetchMailSendResume',
      fetchMailTemplate:       'mailSendResume/fetchMailTemplate',
    }),
    onSelectionChanged() {
      this.ids = this.gridApi.getSelectedRows().map(user => user.id)
    },
    onSortChangedEvent(event){
      let columns = event.columnApi.getAllColumns();
      let root = this;
      columns.forEach(function(column){
        if (column.getSort()){
          root.orderDir = column.getSort()
          root.orderBy  = column.getColId()
          root.searchMailWithOrder();
          return;
        }
      });
    },
    searchMailWithOrder(){
     this.fetchMailSendResume({orderBy: this.orderBy, orderDir: this.orderDir, limit: this.paginationPageSize, page: this.pageNumber,
       mst_company_id: this.searchCondition.companyId, to_email: this.searchCondition.address, template: this.searchCondition.template, state: this.searchCondition.state,
       update_at_start: this.searchCondition.sendFrom, update_at_end: this.searchCondition.sendTo, create_at_start: this.searchCondition.requestFrom, create_at_end: this.searchCondition.requestTo
     })
    },
    async setPagination(val){
      this.gridApi.paginationSetPageSize(val);
      this.pageNumber = 1
      await this.searchMailWithOrder();
      this.ids = []
    },
    async resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()
      this.searchCondition = {
        // Filter Options Search
        companyId: "",
        address: "",
        template: null,
        state: null,
        sendFrom: null,
        sendTo: null,
        requestFrom: null,
        requestTo: null
      }
      await this.searchMailWithOrder()
      this.$refs.filterCard.removeRefreshAnimation()
    },
    showListener(id){
      this.showMailSendResume(id)
        .then(item => {
          this.item           = item
          this.activePopup  = true
      })
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
    EventBus.$on('showRecord', this.showListener)
    // save paginationSize to sessionStorage (when fresh browser)
    const root = this
    window.addEventListener('beforeunload', function(){
      sessionStorage.setItem("paginationPageSize", root.paginationPageSize)
    })
  },
  created () {
    this.searchMailWithOrder();
    this.templateList = [{ key: null, value: '...'}]
    this.fetchMailTemplate().then((data) => {
      this.templateList = this.templateList.concat(data);
    });
  },
  beforeMount(){
    // set page after load (change route = 10, refresh = save PaginationSize in SessionStorage )
    let paginationPageSize = sessionStorage.getItem("paginationPageSize");
    if (paginationPageSize !== null) this.paginationPageSize = paginationPageSize
  },
  updated(){
    // set paginationPageSize = 10 (default) when change page/route
    sessionStorage.setItem("paginationPageSize", 10)
    // calc number startRow and endRow
    this.$nextTick(()=>{
      if(!this.$store.state.loading && this.items.length > 0){
        this.startRow = this.pageNumber * this.paginationPageSize - this.paginationPageSize + 1
        if(this.items.length == this.paginationPageSize) this.endRow = this.pageNumber*this.paginationPageSize
        else this.endRow = this.paginationPageSize*this.pageNumber + this.items.length - this.paginationPageSize
      }
      if(this.items.length == 0){
        this.endRow = 0
        this.startRow = 0
      }
    });
  },
  beforeDestroy(){
    EventBus.$off('showRecord', this.showListener);
  },
  destroyed(){
    // hiden popup while edit/update => click back/next on broswer (use activePopup = false not working)
    document.getElementById('dialogUpdate').style.display = 'none'
  }
}

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/view/kinds.scss"
</style>
